import { EnvironmentBanner } from "@homebound/beam";
import { getBackendStage } from "src/context";
import { useCurrentInternalUserQuery } from "src/queries/user.generated";

export function EnvBanner() {
  const stage = getBackendStage();
  const { data } = useCurrentInternalUserQuery();
  const isImpersonating = data?.currentInternalUser?.user?.isBeingImpersonated;

  return (
    <EnvironmentBanner
      env={stage}
      impersonating={isImpersonating ? { name: data?.currentInternalUser?.name ?? "" } : undefined}
    />
  );
}
